import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RfvslmnpRequest } from '../interfaces/rfvslmnp-request.interface';
import { RfvslmnpResponse } from '../interfaces/rfvslmnp-response.interface';

@Injectable({
  providedIn: 'root',
})
export class RfvslmnpService {
  private readonly http = inject(HttpClient);

  public postRfvslmnpSimulation(request: Partial<RfvslmnpRequest>): Observable<RfvslmnpResponse> {
    return this.http.post<RfvslmnpResponse>('/rgg/fis/v1/rfvslmnp-simulation', request);
  }
}
